export function WhiteLoadingIndicator() {
  return (
    <div
      className={
        "border-2 h-5 w-5 border-t-white border-gray-200/50 rounded-full animate-spin"
      }
    />
  );
}
